import { createReducer } from "@reduxjs/toolkit";
import {
  loadingData,
  savingData,
  setEditPageTitle,
  setSidebarVisible,
  setTriggerSignClearCount,
  setMenuViewStyle,
  setPageViewStyle,
  setGridPageSize,
  setListPageSize,
  setSupplierPageViewStyle,
  setCustomerPageViewStyle,
} from "./commonAction";

export interface Common {
  isSaving: boolean;
  isLoading: boolean;
  editPageTitle: string;
  sidebarVisible: boolean;
  triggerSignClearCount: number;
  menuViewStyle: "list" | "grid";
  pageViewStyle: "list" | "grid";
  gridPageSize: number;
  listPageSize: number;
  supplierPageViewStyle: "list" | "image";
  customerPageViewStyle: "list" | "image";
}

// Load initial menu style from localStorage or default to 'list'
const getInitialMenuViewStyle = (): "list" | "grid" => {
  const saved = localStorage.getItem("menuViewStyle");
  return saved === "grid" ? "grid" : "list";
};

const getInitialPageViewStyle = (): "list" | "grid" => {
  const saved = localStorage.getItem("pageViewStyle");
  return saved === "grid" ? "grid" : "list";
};

const getInitialGridPageSize = (): number => {
  const saved = localStorage.getItem("gridPageSize");
  return saved ? parseInt(saved, 10) : 72;
};

const getInitialListPageSize = (): number => {
  const saved = localStorage.getItem("listPageSize");
  return saved ? parseInt(saved, 10) : 25;
};
const getInitialSupplierPageViewStyle = (): "list" | "image" => {
  const saved = localStorage.getItem("supplierPageViewStyle");
  return saved === "image" ? "image" : "list";
};
const getInitialCustomerPageViewStyle = (): "list" | "image" => {
  const saved = localStorage.getItem("customerPageViewStyle");
  return saved === "image" ? "image" : "list";
};
const initialState: Partial<Common> = {
  editPageTitle: "",
  sidebarVisible: true,
  triggerSignClearCount: 0,
  menuViewStyle: getInitialMenuViewStyle(),
  pageViewStyle: getInitialPageViewStyle(),
  gridPageSize: getInitialGridPageSize(),
  listPageSize: getInitialListPageSize(),
  supplierPageViewStyle: getInitialSupplierPageViewStyle(),
  customerPageViewStyle: getInitialCustomerPageViewStyle(),
};

export const commonReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(savingData, (state, action) => {
      state = {
        ...state,
        isSaving: action.payload,
      };
      return state;
    })
    .addCase(loadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(setEditPageTitle, (state, action) => {
      state = {
        ...state,
        editPageTitle: action.payload,
      };
      return state;
    })
    .addCase(setSidebarVisible, (state, action) => {
      state = {
        ...state,
        sidebarVisible: action.payload,
      };
      return state;
    })
    .addCase(setTriggerSignClearCount, (state, action) => {
      state = {
        ...state,
        triggerSignClearCount: action.payload,
      };
      return state;
    })
    .addCase(setMenuViewStyle, (state, action) => {
      // Persist to localStorage
      localStorage.setItem("menuViewStyle", action.payload);
      state = {
        ...state,
        menuViewStyle: action.payload,
      };
      return state;
    })
    .addCase(setPageViewStyle, (state, action) => {
      // Persist to localStorage
      localStorage.setItem("pageViewStyle", action.payload);
      state = {
        ...state,
        pageViewStyle: action.payload,
      };
      return state;
    })
    .addCase(setSupplierPageViewStyle, (state, action) => {
      // Persist to localStorage
      localStorage.setItem("supplierPageViewStyle", action.payload);
      state = {
        ...state,
        supplierPageViewStyle: action.payload,
      };
      return state;
    })
    .addCase(setGridPageSize, (state, action) => {
      // Persist to localStorage
      localStorage.setItem("gridPageSize", action.payload.toString());
      state = {
        ...state,
        gridPageSize: action.payload,
      };
      return state;
    })
    .addCase(setListPageSize, (state, action) => {
      // Persist to localStorage
      localStorage.setItem("listPageSize", action.payload.toString());
      state = {
        ...state,
        listPageSize: action.payload,
      };
      return state;
    })
    .addCase(setCustomerPageViewStyle, (state, action) => {
      localStorage.setItem("customerPageViewStyle", action.payload);
      state = {
        ...state,
        customerPageViewStyle: action.payload,
      };
      return state;
    });
});
